import type { Breadcrumb } from '@benzinga/content-manager';
import type { PresetType } from '@benzinga/scanner-widget';

export const PRESET_TITLES: Record<PresetType, string> = {
  'largest-increase': 'Largest Increase in Short Interest',
  'largest-decrease': 'Largest Decrease in Short Interest',
  'most-shorted': 'Most Shorted Stocks',
};

const PRESET_BREADCRUMB_NAMES: Record<PresetType, string> = {
  'largest-increase': 'Largest Increase',
  'largest-decrease': 'Largest Decrease',
  'most-shorted': 'Most Shorted Stocks',
};

const BASE_BREADCRUMBS: Breadcrumb[] = [
  { href: '/calendars', id: 'calendars', name: 'Calendars' },
  { href: '/short-interest', id: 'short-interest', name: 'Short Interest' },
];

export function getShortInterestBreadcrumbs(preset: PresetType | undefined): Breadcrumb[] {
  if (!preset || !(preset in PRESET_BREADCRUMB_NAMES)) return BASE_BREADCRUMBS;
  return [
    ...BASE_BREADCRUMBS,
    { href: `/short-interest/${preset}`, id: preset, name: PRESET_BREADCRUMB_NAMES[preset as PresetType] },
  ];
}

const VALID_PRESETS: PresetType[] = ['most-shorted', 'largest-increase', 'largest-decrease'];

export function presetFromPathname(pathname: string): PresetType {
  const segment = pathname.replace(/^\/short-interest\/?/, '').split('/')[0] || '';
  return VALID_PRESETS.includes(segment as PresetType) ? (segment as PresetType) : 'most-shorted';
}
